import { call, put, takeLatest } from 'redux-saga/effects';
import api from '../../../api-new/http';
import { 
    fetchOngoingContestFailure, 
    FetchOngoingContestRequestAction, 
    fetchOngoingContestSuccess,
    fetchContestDetailFailure,
    FetchContestDetailRequestAction,
    fetchContestDetailSuccess
} from './actions';
import { FETCH_ONGOING_CONTEST_REQUEST, FETCH_CONTEST_DETAIL_REQUEST } from './constants';
import { SagaIterator } from 'redux-saga';
import { sendError } from '../errorHandler';
import { getErrorSetup } from '../../../helpers/getErrorSetup';
import { appUrls } from '../../../api-new/urls';

export function* OngoingContestSaga(action: FetchOngoingContestRequestAction): SagaIterator {
    try { 
        // Try to get ongoing contest first
        let data: any = yield call(() => api.get(`${appUrls.tradeURL}/contests/ongoing`));

        if (data?.data.data === null) {
            // No ongoing contest, try incoming
            data = yield call(() => api.get(`${appUrls.tradeURL}/contests/incoming`));
        }
        if (data?.data.data === null) {
            // No incoming contest, get latest ended contest
            data = yield call(() => api.get(`${appUrls.tradeURL}/contests/latest`));
        }

        if (data?.data && data.data.data) {
            // Data already includes rankList and participants from getContestById
            yield put(fetchOngoingContestSuccess(data.data.data));
        }
    } catch (error) {
        yield put(fetchOngoingContestFailure(error as any));
        yield put(
            sendError({
                error: getErrorSetup(error),
                processingType: 'alert',
            }),
        );
    }
}

export function* ContestDetailSaga(action: FetchContestDetailRequestAction): SagaIterator {
    try {
        const contestId = action.payload;
        const data: any = yield call(() => api.get(`${appUrls.tradeURL}/contests/${contestId}`));

        if (data?.data) {
            yield put(fetchContestDetailSuccess(data.data.data));
        }
    } catch (error) {
        yield put(fetchContestDetailFailure(error as any));
        yield put(
            sendError({
                error: getErrorSetup(error),
                processingType: 'alert',
            }),
        );
    }
}

export function* rootContestSaga(): Generator {
    yield takeLatest(FETCH_ONGOING_CONTEST_REQUEST, OngoingContestSaga);
    yield takeLatest(FETCH_CONTEST_DETAIL_REQUEST, ContestDetailSaga);
}
